<template>
  <el-dialog
    title="工号编辑"
    :visible.sync="showDialog"
    :modal-append-to-body="false"
    :append-to-body="true"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    @close="close"
    width="40%"
  >
    <div class="dialog_box">
      <el-form
        ref="ruleForm"
        :rules="rules"
        :model="dataInfo"
        label-width="0px"
      >
        <div class="form-row-item-box">
          <div class="form-item-box">
            <span>名称:</span>
            <el-form-item>
              <el-input
                size="small"
                clearable
                style="width:100%"
                :disabled='true'
                v-model.trim="dataInfo.userName"
              ></el-input>
            </el-form-item>
          </div>
          <div class="form-item-box">
            <span>工号:</span>
            <el-form-item prop="roleName">
              <el-input
                size="small"
                clearable
                style="width:100%"
                v-model.trim="dataInfo.jobNumber"
              ></el-input>
            </el-form-item>
          </div>
        </div>
      </el-form>
      <div class="dialog_save_cancel_box">
        <div class="cancel_item_box" @click="close">取消</div>
        <div class="save_item_box" @click="saveClick('ruleForm')">确定</div>
      </div>
    </div>
  </el-dialog>
</template>

<script>
//这里可以引入其他文件（比如组件，工具js，第三方插件js，json文件，图片文件等等）
//列如：import <<组件名称>> from '《组件路径》';
export default {
  //import引入的组件需要注入到对象中才能使用
  components: {},
  props: {
    showDialog: {
      type: Boolean,
      default: () => {
        return false;
      }
    },
    dialogInfo: {
      type: Object,
      default: () => {
        return {};
      }
    }
  },
  data() {
    //这里存放数据
    return {
      rules: {
        jobNumber: [{ required: true, message: " ", trigger: "blur" }]
      },
      dataInfo: {}
    };
  },
  //监控data中的数据变化
  watch: {
    showDialog: function(val) {
      if (val) {
        this.dataInfo = this.dialogInfo;
      }
    }
  },
  //计算属性，类似于data概念
  computed: {},
  //方法集合
  methods: {
    close() {
        this.$refs.ruleForm.resetFields();
      this.$emit("close");
    },
    saveClick(formName) {
      if (this.dataInfo.jobNumber.length != 6) {
        this.$message({
          message: "请输入六位数工号！",
          type: "warning"
        });
        return;
      }
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.$emit("saveClick", this.dataInfo);
        } else {
          return false;
        }
      });
    }
  },
  //生命周期，创建完成（可以访问当前this实例）
  created() {},
  //生命周期，挂载完成（可以访问dom元素）
  mounted() {},
  beforeCreate() {}, //生命周期-创建之前
  beforeMount() {}, //生命周期 - 挂载之前
  beforeUpdate() {}, //生命周期 - 更新之后
  updated() {}, //生命周期 - 更新之后
  beforeDestroy() {}, //生命周期 - 销毁之前
  destroy() {}, //生命周期 - 销毁完成
  activated() {} //如果页面有keep-alive缓存功能，这个函数会触发
};
</script>
<style scoped lang="scss">
@import "../../../../../public/css/edu_pages.scss";
</style>
